<template>
  <div class="navbar-default box-shadow flex">
    <el-page-header @back="$emit('close-dialog')">
      <template v-slot:content
        >表单设计({{ formData.name }})</template
      >
    </el-page-header>
    <span>
      <el-button
        icon="icon-technology"
        v-if="formId"
        @click="includdingFile('')"
        >引入脚本</el-button
      >
      <el-button icon="icon-list" v-if="formId" @click="historyRecord"
        >表单历史记录</el-button
      >
      <el-button icon="icon-save" type="primary" @click="save('notPublish')">保存</el-button>
      <el-button
        icon="icon-release"
        @click="publish(1)"
        v-if="formId && formData.status == 'draft' && formData.isPrint != 'Y'"
        >发布</el-button
      >
      <el-button icon="icon-release" @click="newVersion" v-else-if="formId && formData.isPrint != 'Y'"
        >发布新版</el-button
      >
      <el-button v-if="formId" @click="previewForm()">
        <el-tooltip content="先(保存|发布)再预览">
          <i class="icon-question" style="margin-right: 8px" /> </el-tooltip
        >预览
      </el-button>
    </span>
    <el-dialog
      title="表单数据"
      :visible.sync="dialogFormVisible"
      append-to-body
      class="urgent-text"
      :close-on-click-modal="false"
      width="1024"
      top="8vh"
    >
      <el-row style="height:500px;">
        <el-col :span="24" style="padding:5px;height:500px;">
          <codemirror
            ref="mycode"
            v-model="formHtml"
            :options="cmOptions"
            class="mycode"
            style="width: 99%;height:500px;"
          ></codemirror>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="引入脚本"
      :visible.sync="dialogincluddingFileVisible"
      append-to-body
      class="urgent-text"
      :close-on-click-modal="false"
      width="1024"
      top="8vh"
    >
      <el-row style="height:100%">
        <el-col :span="14" style="padding:5px;height:100%; margin-top: 79px">
          <codemirror
            ref="mycode"
            v-model="formHtml"
            :options="cmOptions"
            class="mycode"
            style="width: 99%;height:100%;"
          ></codemirror>
        </el-col>
        <el-col :span="10" style="padding:5px;">
          <span>自定义JS脚本</span>&nbsp;&nbsp;
          <el-dropdown @command="variablesClick" size="mini">
            <el-button type="primary">
              常用变量
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{ value: 'currentUser.account' }"
                >当前用户账号</el-dropdown-item
              >
              <el-dropdown-item :command="{ value: 'currentUser.username' }"
                >当前用户名称</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <br />
          <span style="color: red;"
            >编辑的脚本内容会直接填充到【script】里面；如需使用到表单BO数据例：data.实体表名.实体表字段</span
          >
          <codemirror
            ref="mycode2"
            v-model="includeFiles.diyJs"
            :options="cmOptions2"
            class="code"
            style="width: 99%;height:100%;"
          ></codemirror>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="includeFilesOk">确 定</el-button>
        <el-button
          @click="
            dialogincluddingFileVisible = false;
            includeFiles.diyJs = '';
          "
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <fe-load-data
      :url.sync="formHtmlUrl"
      context="form"
      @after-load-data="afterformHtml"
    ></fe-load-data>
    <el-dialog
      title="表单历史记录"
      :visible.sync="historyRecordVisible"
      append-to-body
      class="urgent-text"
      :close-on-click-modal="false"
      width="1024"
      top="8vh"
    >
      <eco-table
        @load="loadData"
        :data="tableData"
        :pageResult="pageResult"
        :selectable="false"
        :show-export="false"
        ref="ecoTable"
        :show-custom-column="false"
      >
        <template>
          <eco-table-column
            type="index"
            width="50"
            align="center"
            label="序号"
          />
          <eco-table-column prop="formId" width="200" label="表单ID" />
          <eco-table-column
            prop="createTime"
            width="200"
            label="创建时间"
            :sortable="true"
          />
          <eco-table-column label="操作">
            <template v-slot="{ row }">
              <el-button type="primary" @click="getFormHistoryRecord(row)"
                >查看表单数据</el-button
              >
              <el-button type="success" @click="updateFormHistoryRecord(row)"
                >恢复</el-button
              >
              <el-button type="danger" @click="delFormHistoryRecord(row)"
                >删除</el-button
              >
            </template>
          </eco-table-column>
        </template>
      </eco-table>
    </el-dialog>
  </div>
</template>
<script>
import request from "@/request.js";
import form from "@/api/form.js";
import utils from "@/eco-ui-util.js";
import { mapState } from "vuex";
import { Base64 } from "js-base64";
import controlsApi from "@/api/controlsConfig.js";
import { Message } from "element-ui";
export default {
  props: ["widgetForm", "formData", "formId"],
  data() {
    return {
      params: null,
      dialogFormVisible: false, //查看表单数据dialog
      dialogincluddingFileVisible: false, //引入脚本dialog
      historyRecordVisible: false, //表单历史记录dialog
      newVersionConfig: false,
      formHtmlUrl: "", //获取表单HTML url
      formHtml: "", //获取表单HTML
      tableData: [], //表单历史记录列表数据
      pageResult: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      includeFiles: { diyFile: "", diyCss: "", diyJs: "" }, //引入脚本和样式对象
      cmOptions: {
        value: "",
        mode: "vue",
        readOnly: false,
        smartIndent: true,
        tabSize: 2,
        theme: "base16-light",
        lineNumbers: true,
        line: true
      },
      cmOptions2: {
        value: "",
        mode: "javascript",
        readOnly: false,
        smartIndent: true,
        tabSize: 2,
        theme: "base16-light",
        lineNumbers: true,
        line: true
      },
      clickCount: 0
    };
  },
  computed: {
    ...mapState({
      currentUser: state => state.login.currentUser
    })
  },
  methods: {
    //查看表单数据
    getFormHistoryRecord(row) {
      const this_ = this;
      this_.dialogFormVisible = true;
      request
        .get("${form}/form/form/v1/getFormHistoryRecord?id=" + row.id)
        .then(function(rep) {
          if (rep) {
            this_.formHtml = row.formHtml;
          }
        });
    },
    //恢复表单数据
    updateFormHistoryRecord(row) {
      const this_ = this;
      request
        .get("${form}/form/form/v1/updateFormHistoryRecord?id=" + row.id)
        .then(function(rep) {
          if (rep.data.state) {
            Message.success(rep.data.message);
            let param = {
              pageBean: { page: 1, pageSize: 20, showTotal: true },
              querys: [
                {
                  property: "formId",
                  value: row.formId,
                  operation: "EQUAL",
                  relation: "AND"
                }
              ]
            };
            this_.loadData(param);
          }
        });
    },
    //删除表单数据
    delFormHistoryRecord(row) {
      const this_ = this;
      request
        .remove("${form}/form/form/v1/delFormHistoryRecord?id=" + row.id)
        .then(function(rep) {
          if (rep.data.state) {
            Message.success("删除成功");
            let param = {
              pageBean: { page: 1, pageSize: 20, showTotal: true },
              querys: [
                {
                  property: "formId",
                  value: row.formId,
                  operation: "EQUAL",
                  relation: "AND"
                }
              ]
            };
            this_.loadData(param);
          }
        });
    },
    variablesClick(data) {
      this.includeFiles.diyJs += data.value;
    },
    //加载表单历史记录列表数据
    loadData(param, cb) {
      const this_ = this;
      let queryUrl = "${form}/form/form/v1/formHistoryRecordlistJson";
      let pageBean = {
        pageBean: { page: "1", pageSize: "10", showTotal: "true" },
        querys: [
          {
            property: "formId",
            value: this_.formData.id,
            operation: "EQUAL",
            relation: "AND"
          }
        ]
      };
      request
        .post(queryUrl, pageBean)
        .then(response => {
          this_.tableData = response.data.rows;
          this_.pageResult = {
            page: response.data.page,
            pageSize: response.data.pageSize,
            total: response.data.total
          };
        })
        .finally(() => cb && cb());
    },
    //打开引入表单历史记录列表对话框
    historyRecord() {
      const this_ = this;
      this_.historyRecordVisible = true;
      let param = {
        pageBean: { page: 1, pageSize: 20, showTotal: true },
        querys: [
          {
            property: "formId",
            value: this_.formData.id,
            operation: "EQUAL",
            relation: "AND"
          }
        ]
      };
      this_.loadData(param);
    },
    afterformHtml(data) {
      if (data && data.bpmForm) {
        this.formHtml = data.bpmForm.formHtml;
        this.includeFiles.diyJs = data.bpmForm.diyJs;
      }
    },
    //打开引入脚本对话框
    includdingFile(formId) {
      if (!formId) {
        formId = this.formData.id;
      }
      this.dialogincluddingFileVisible = true;
      this.formHtmlUrl = "/form/form/v1/previewDesignVue?formId=" + formId;
      this.includeFiles = this.formData.includeFiles
        ? Base64.decode(this.formData.includeFiles, "utf-8")
        : { diyFile: " ", diyCss: " ", diyJs: " " };
    },
    //引入脚本和样式对象保存
    includeFilesOk() {
      if (!this.formHtml) {
        this.$message.warning("模板HTML不能为空！");
        return;
      }
      this.dialogincluddingFileVisible = false;
      form
        .saveFormJs({
          formId: this.formData.id,
          diyJs: this.includeFiles.diyJs,
          formHtml: Base64.encode(this.formHtml, "utf-8")
        })
        .then(resp => {
          if (resp.state) {
            this.$message.success(resp.message);
          }
        });
    },
    //布局字段中嵌入了布局字段的情况
    isSave(list) {
      let flag = false;
      //不需要绑定表单属性的控件
      let ctrlTypeList = [
        "grid",
        "text",
        "accordion",
        "tab",
        "immediate-single",
        "immediate-textarea",
        "image",
        "iframe",
        "amap"
      ];
      for (let i = 0; i < list.length; i++) {
        if (
          list[i].ctrlType == "grid" ||
          list[i].ctrlType == "accordion" ||
          list[i].ctrlType == "tab"
        ) {
          for (let j = 0; j < list[i].columns.length; j++) {
            if (list[i].columns[j].list.length > 0) {
              for (let k = 0; k < list[i].columns[j].list.length; k++) {
                if (
                  list[i].columns[j].list[k].name == "" &&
                  ctrlTypeList.indexOf(list[i].columns[j].list[k].ctrlType) ==
                    -1
                ) {
                  this.$message.error(
                    "【" +
                      list[i].desc +
                      "中的" +
                      list[i].columns[j].list[k].desc +
                      "】未绑定表单属性"
                  );
                  flag = true;
                  return flag;
                }
              }
            }
          }
        }
      }
      return flag;
    },
    getPostData() {
      if (this.widgetForm.list.length == 0) {
        this.$message.error("请拖拽表单控件");
        return;
      }
      //不需要绑定表单属性的控件
      let ctrlTypeList = [
        "grid",
        "text",
        "accordion",
        "tab",
        "immediate-single",
        "immediate-textarea",
        "image",
        "iframe",
        "amap"
      ];
      for (let i = 0; i < this.widgetForm.list.length; i++) {
        if (
          this.widgetForm.list[i].ctrlType == "grid" ||
          this.widgetForm.list[i].ctrlType == "accordion" ||
          this.widgetForm.list[i].ctrlType == "tab"
        ) {
          for (let j = 0; j < this.widgetForm.list[i].columns.length; j++) {
            if(this.widgetForm.list[i].columns[j].span.length > 20){
              this.$message({message: "tab布局控件第"+ (j + 1) +"个标签配置项字符长度超出20！", type : "error"});
              return;
            }
            if (this.widgetForm.list[i].columns[j].list.length > 0) {
              for (
                let k = 0;
                k < this.widgetForm.list[i].columns[j].list.length;
                k++
              ) {
                //判断布局字段中是否嵌入了布局字段
                if (
                  this.widgetForm.list[i].columns[j].list[k].name == "" &&
                  (this.widgetForm.list[i].columns[j].list[k].ctrlType ==
                    "grid" ||
                    this.widgetForm.list[i].columns[j].list[k].ctrlType ==
                      "accordion" ||
                    this.widgetForm.list[i].columns[j].list[k].ctrlType ==
                      "tab")
                ) {
                  let flag = this.isSave(
                    this.widgetForm.list[i].columns[j].list
                  ); //布局字段中嵌入了布局字段
                  if (flag) {
                    return;
                  }
                } else if (
                  this.widgetForm.list[i].columns[j].list[k].name == "" &&
                  ctrlTypeList.indexOf(
                    this.widgetForm.list[i].columns[j].list[k].ctrlType
                  ) == -1
                ) {
                  this.$message.error(
                    "【" +
                      this.widgetForm.list[i].desc +
                      "中的" +
                      this.widgetForm.list[i].columns[j].list[k].desc +
                      "】未绑定表单属性"
                  );
                  return;
                }
              }
            }
          }
        }
      }
      var resp = this.judgeWidgetFormList(this.widgetForm.list);
      if (resp) {
        const formDef = {
          expand: JSON.stringify(this.widgetForm),
          rev: this.formData.rev
        };
        formDef.name = this.formData.name;
        formDef.key = this.formData.formKey;
        formDef.type = this.formData.typeName;
        formDef.typeId = this.formData.typeId;
        formDef.macroAlias = this.formData.macroAlias;
        formDef.mainAlias = this.formData.mainAlias;
        if (this.formData.defId) {
          formDef.id = this.formData.defId;
        }
        let bpmFormVo = {
          bpmFormDef: formDef,
          bpmForm: this.formData
        };
        if (this.newVersionConfig) {
          bpmFormVo.newForm = "newForm";
        }
        return bpmFormVo;
      }
    },
    publish(i) {
      if (i == 1) {
        this.save();
      }
      i++;
      if (this.isPublish) {
        this.$http
          .post("${form}/form/form/v1/publish", {}, { formId: this.formId })
          .then(response => {
            if (response.data.state) {
              this.$message({
                type: "success",
                message: response.data.message
              });
              this.formData.status = "deploy";
              this.$emit("close-dialog");
            }
          });
      } else {
        setTimeout(() => this.publish(i), 500);
      }
    },
    newVersion() {
      this.newVersionConfig = true;
      this.save();
    },
    save(param) {
      this.notPublish = true;
      if(param){
        this.notPublish = false;
      }
      //先校验表单的基本属性
      this.$emit("saveValidate");
    },
    saveEnd() {
      let params = this.getPostData();
      this.newVersionConfig = false;
      if (params) {
        const this_ = this;
        //保存表单是先判断是否有表单模板，没有表单模板先初始化表单模板
        form.isTemplateByAlias("fieldControl").then(resp => {
          if (resp.data.value != undefined) {
            //保存表单
            this_.saveForm(params, this_);
          } else {
            //初始化表单模板
            form.initTemplate().then(response => {
              if (response.data.state) {
                //保存表单
                this_.saveForm(params, this_);
              }
            });
          }
        });
      }
    },
    //保存表单
    saveForm(params, this_) {
      
      if(this.clickCount == 0){
        ++this.clickCount;
        request.post("${form}/form/form/v1/saveForm", params).then(
                response => {
                  this_.$message.success(response.data.message);
                  this_.$emit("close-dialog", response.data.value);
                  if(this.notPublish){
                    this.isPublish = true;
                  }
                  setTimeout(()=>{
                    this.clickCount = 0;
                  }, 2000)
                },
                error => {
                  this.$message.error(
                          error.response.data.message ||
                          "表单保存失败！请检查表单模板是否正确"
                  );
                  this.isPublish = false;
                  setTimeout(()=>{
                    this.clickCount = 0;
                  }, 2000)
                }
        );
      }
    },
    previewForm() {
      if (this.currentUser && this.currentUser.account) {
        let url = "";
        if (this.formData.formType == "pc") {
          url =
            window.context.front +
            "/previewForm/" +
            this.formId +
            "?token=" +
            this.currentUser.token;
          // Base64.encode(this.currentUser.account);
        } else {
          url =
            window.context.mobile +
            "/previewForm/" +
            this.formId +
            "?token=" +
            this.currentUser.token;
          // Base64.encode(this.currentUser.account);
        }
        window.open(url, "_blank");
      }
    },
    genHtml() {
      request
        .post("${form}/form/form/v1/generateFrom", this.getPostData())
        .then(response => {
          this.$message.success(response.data.message);
          this.$emit("close-dialog");
        });
    },
    editHtml() {},

    judgeWidgetFormList(widgetFormList) {
      // 判断表单当中，有必须绑定属性的控件没有绑定属性
      let resultVal = true;
      let fieldList = [];
      for (var i = 0; i < widgetFormList.length; i++) {
        var listValue = this.widgetForm.list[i];
        if (listValue.columns) {
          // 栅格布局的字段保存  tab 折叠
          for (var j = 0; j < listValue.columns.length; j++) {
            var listValue1 = [];
            //非布局字段
            var fieldListValue1 = listValue.columns[j].list.filter(c => {
              !controlsApi.isLayoutComponents(c.ctrlType) &&
                !c.options.noBindModel &&
                c.options.noBindModel != undefined;
            });
            listValue1 = listValue1.concat(fieldListValue1);
            //栅格布局
            var gridListValue1 = listValue.columns[j].list.filter(
              c => c.ctrlType == "grid"
            );
            for (let k = 0; k < gridListValue1.length; k++) {
              var columnsObj = gridListValue1[k].columns;
              for (let l = 0; l < columnsObj.length; l++) {
                var list = columnsObj[l].list;
                list = list.filter(c => {
                  return !c.options.noBindModel;
                });
                listValue1 = listValue1.concat(list);
              }
            }
            fieldList = fieldList.concat(listValue1);
            //子表布局
            var subtableListValue1 = listValue.columns[j].list.filter(
              c => c.ctrlType == "subtable" ||c.ctrlType == "tableRowLayout" || c.ctrlType == "subDiv"
            );

            for (let k = 0; k < subtableListValue1.length; k++) {
              var subObj = subtableListValue1[k];
              if (subObj.list) {
                if (!this.subUnique(subObj)) {
                  return false;
                }
              }
            }
            resultVal = this.validateFields(listValue1);
            if (!resultVal) {
              return false;
            }

            //数据视图
            var dataViewListValue1 = listValue.columns[j].list.filter(
              c => c.ctrlType == "dataView"
            );

            for (let k = 0; k < dataViewListValue1.length; k++) {
              var dataView = dataViewListValue1[i];
              if (dataView.templateKey == "") {
                this.$message.error("请绑定数据报表");
                return false;
              }
            }
            for(let f=0;f<fieldList.length;f++){
              for(let v=0;v<listValue.columns[j].list.length;v++){
                if(listValue.columns[j].list[v].name==fieldList[f].name && fieldList[f].target){
                  this.$message.error("字段属性【" + fieldList[f].name + "】,绑定了多个布局控件");
                  return false;
                }
              }
            }
            // if (listValue.ctrlType == "grid") {
              fieldList = fieldList.concat(listValue.columns[j].list);
            // }

          }
        } else if (listValue.list) {
          var res = this.subUnique(listValue);
          if (!res) {
            return false;
          }
        } else if (!listValue.options.noBindModel) {
          fieldList.push(listValue);
          // 不使用布局
          resultVal = this.validateField(listValue);
          if(!resultVal){
            break;
          }
        } else if (listValue.templateKey) {
          if (listValue.templateKey == "") {
            //数据视图
            this.$message.error("请绑定数据报表");
            return false;
          }
        }
      }
      let obj = this.unique(fieldList);
      if (this.unique(fieldList)) {
        let repeatArray = fieldList.filter(item => {
          return item.fieldPath === obj.fieldPath;
        });
        let desc = "";
        let title = repeatArray[0].title;
        if (!title) {
          title = repeatArray[0].fieldPath;
        }
        repeatArray.forEach(item => {
          desc = desc + item.desc + ",";
        });
        this.$message.error(
          "属性【" + title + "】,绑定了多个控件"
        );
        return false;
      }
      return resultVal;
    },
    subUnique(listValue) {
      let res = true;
      if (!listValue.options.boSubEntity) {
        this.$message.error(listValue.desc + "请绑定实体");
        return false;
      }
      if (listValue.list.length == 0) {
        this.$message.error(listValue.desc + "请至少绑定一个子表字段");
        return false;
      }
      //获取孙表字段
      let sunList = listValue.list.filter(
        c => c.ctrlType == "suntable" || c.ctrlType == "sunDiv"
      );
      for (let k = 0; k < sunList.length; k++) {
        if (!sunList[k].options.boSubEntity) {
          this.$message.error(sunList[k].desc + "请绑定实体");
          return false;
        }
        if (sunList[k].list.length == 0) {
          this.$message.error(sunList[k].desc + "请至少绑定一个孙表字段");
          return false;
        }
        let sunFieldList = this.getField(sunList[k]);
        if (this.unique(sunFieldList)) {
          let repeatArray = sunFieldList.filter(item => {
            return item.fieldPath === obj.fieldPath;
          });
          let desc = "";
          let title = repeatArray[0].title;
          if (!title) {
            title = repeatArray[0].fieldPath;
          }
          repeatArray.forEach(item => {
            desc = desc + item.desc + ",";
          });
          this.$message.error(
            listValue.desc +
              "孙表中属性【" +
              title +
              "】,绑定了多个控件【" +
              desc +
              "】,只能绑定一个"
          );
          return false;
        }
        if (!this.validateFields(sunFieldList)) {
          return false;
        }
      }

      let subFieldList = this.getField(listValue);
      let obj = this.unique(subFieldList);
      if (obj) {
        let repeatArray = subFieldList.filter(item => {
          return item.fieldPath === obj.fieldPath;
        });
        let desc = "";
        let title = repeatArray[0].title;
        if (!title) {
          title = repeatArray[0].fieldPath;
        }
        repeatArray.forEach(item => {
          desc = desc + item.desc + ",";
        });
        this.$message.error(
          listValue.desc +
            "子表中属性【" +
            title +
            "】,绑定了多个控件【" +
            desc +
            "】,只能绑定一个"
        );
        return false;
      }
      if (!this.validateFields(subFieldList)) {
        return false;
      }
      return res;
    },
    getField(listValue) {
      //获取布局中栅格布局
      let gridListValue1 = listValue.list.filter(c => c.ctrlType == "grid");
      //获取布局中基础字段
      let subFieldList = listValue.list.filter(
        c =>
          c.ctrlType != "grid" &&
          (c.ctrlType != "suntable" || c.ctrlType != "sunDiv")
      );
      for (let k = 0; k < gridListValue1.length; k++) {
        let columnsObj = gridListValue1[k].columns;
        for (let l = 0; l < columnsObj.length; l++) {
          let list = columnsObj[l].list;
          subFieldList = subFieldList.concat(list);
        }
      }
      return subFieldList;
    },
    unique(arr) {
      var hash = {};
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].fieldPath && hash[arr[i].fieldPath]) {
          return arr[i];
        }
        hash[arr[i].fieldPath] = true;
      }
      return false;
    },
    validateFields(fields) {
      let resultVal = true;
      for (var k = 0; k < fields.length; k++) {
        resultVal = this.validateField(fields[k]);
        if (!resultVal) {
          return false;
        }
      }
      return true;
    },
    validateField(field) {
      if (!field.options.noBindModel && field.name == "") {
        this.$message.error("请绑定表单属性");
        return false;
      }
      if (field.ctrlType == "selector" && !field.options.selector.type.alias) {
        this.$message.error("选择器控件请绑定选择器");
        return false;
      }
      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.navbar-default {
  height: 100%;
  background-image: none;
  background: #fff;
  border-radius: 0px;
  box-shadow: 0px 2px 5px rgba(86, 96, 117, 0.15);
  border-bottom: 1px solid #ededed;
  justify-content: space-between;
  padding: 0 10px;
}

.navbar-default span {
  color: #666;
  font-size: 14px;
  line-height: 48px;
  font-weight: bold;
  margin-left: 20px;
}

.navbar-default button {
  margin-right: 10px;
}
div >>> .CodeMirror {
  font-family: monospace;
  height: 450px !important;
  color: black;
  direction: ltr;
}
</style>
